module.exports = __webpack_public_path__ + "img/step8.383692c0.png";